function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */
import axios from 'axios';
import AxiosUtils from '../../utilities/axios-utils';
import checkUtils from '../../utilities/check-utils';
import ConfigurationManager from '../configuration-manager';

/**
 * @memberOf module:wdh-feature-b2b
 */
var ApiClientWarranty = /*#__PURE__*/function () {
  function ApiClientWarranty(token) {
    _classCallCheck(this, ApiClientWarranty);
    this.token = token;
  }
  return _createClass(ApiClientWarranty, [{
    key: "initErrorHandling",
    value: function initErrorHandling(callback) {
      this.errorHandlingCallback = callback;
    }

    /**
    * Retrieves warranties for an item number
    */
  }, {
    key: "get",
    value: function get(itemNumber) {
      var _this = this;
      var productId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var appendModel = '';
      if (!checkUtils.isNullOrEmptyString(productId)) {
        appendModel = "&model=".concat(productId);
      }
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/warranties?itemNo=".concat(itemNumber).concat(appendModel), AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }
  }, {
    key: "getStandardWarranty",
    value: function getStandardWarranty(itemNumber) {
      var _this2 = this;
      var isChild = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var categoryId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var clientOrderId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var appendIsChild = '';
      var appendCategoryid = '';
      var appendClientOrderId = '';
      if (isChild) {
        appendIsChild = "&isChild=".concat(isChild);
      }
      if (categoryId !== '') {
        appendCategoryid = "&categoryId=".concat(categoryId);
      }
      if (clientOrderId !== '') {
        appendClientOrderId = "&clientOrderId=".concat(clientOrderId);
      }
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/stdWarranties?itemNo=".concat(itemNumber).concat(appendIsChild).concat(appendCategoryid).concat(appendClientOrderId), AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this2.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this2.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * grab warranty details for the specified device
     *
     * @param serialNo {string}
     */
  }, {
    key: "getWarrantyDetails",
    value: function getWarrantyDetails(serialNo) {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        axios.get("/api/devices/".concat(serialNo), AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this3.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this3.errorHandlingCallback(err.response.data);
        });
      });
    }

    /**
     * gets information regarding expiring warranties
     *
     * @returns {Promise<object>}
     */
  }, {
    key: "getExpiringSoon",
    value: function getExpiringSoon() {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        axios.get('/api/devices/expiringSoon', AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this4.token)).then(function (response) {
          resolve(response);
        }).catch(function (err) {
          reject(err);
          _this4.errorHandlingCallback(err.response.data);
        });
      });
    }
  }]);
}();
export default ApiClientWarranty;